export const ApplicantWhatsAppIcon = ({
  primaryColor = "var(--primary-bg-color)",
  secondColor = "var(--primary-background-text-color)",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
  >
    <circle cx="24" cy="24" r="24" fill={primaryColor} />
    <path
      fill={secondColor}
      transform="translate(8 8) scale(0.125)"
      d="M128 48c-44.2 0-80 35.8-80 80 0 14.1 3.7 27.4 10.2 38.9L48 208l42-11c11 6 23.7 9.4 36.5 9.4h.5c44.2 0 80-35.8 80-80s-35.8-78.4-79-78.4zm0 144c-11.7 0-23-3.2-32.8-9.2l-2.4-1.4-24.3 6.4 6.5-23.7-1.5-2.5C66.2 151 62 139.7 62 128c0-36.5 29.5-66 66-66s66 29.5 66 66-29.5 66-66 66zm36.5-49.5c-2-1-11.7-5.8-13.5-6.4-1.8-.7-3.1-1-4.4 1-1.3 2-5 6.4-6.1 7.7-1.1 1.3-2.2 1.5-4.2.5-2-1-8.4-3.1-16-9.9-5.9-5.3-9.9-11.8-11-13.8-1.1-2-.1-3.1.9-4.1.9-.9 2-2.3 3-3.5 1-1.1 1.3-2 2-3.3.7-1.3.3-2.5-.2-3.5-.5-1-4.4-10.7-6.1-14.6-1.6-3.8-3.2-3.3-4.4-3.4-1.1 0-2.4-.1-3.7-.1-1.3 0-3.5.5-5.3 2.5s-7 6.8-7 16.6 7.2 19.3 8.2 20.6c1 1.3 14.2 21.7 34.4 30.4 4.8 2.1 8.6 3.3 11.5 4.3 4.8 1.5 9.2 1.3 12.7.8 3.9-.6 11.7-4.8 13.4-9.4 1.6-4.6 1.6-8.6 1.1-9.4-.5-.7-1.8-1.2-3.8-2.2z"
    />
  </svg>
);
